<div class="row" *ngIf="isComercial || isBasica">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <!-- Inicio Linha 1 -->

          <div class="row pt-3">
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Safra<span class="InputRequired">{{required}}</span>
                </mat-label>
                <input matInput id="txtSafra" #txtSafra maxlength="8" formControlName="Safra" [readonly]="true"
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtSafra.value.length}} / 8</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Safra)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Cerar<span class="InputRequired">{{required}}</span>
                </mat-label>
                <input matInput id="txtCerar" #txtCerar maxlength="17" formControlName="Cerar" (blur)="getQua007Data()"
                  (blur)="makeCalculations()" (blur)="checkCerarExist()" class="InputUnblockColor">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-hint align="end">{{txtCerar.value.length}} / 17</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Cerar)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm btnAlignSelf pr-2 pb-2">
              <button mat-flat-button class="btnSize" color="primary" matTooltip="Leitor Cerar" id="btnCerar"
                name="btnCerar" (click)="openDialog()" [disabled]="disableBtnCerar">
                <i class="{{iconBarCodeField}}"></i> Leitor Cerar
              </button>
            </div>
          </div>

          <!-- Fim Linha 1 -->

          <!-- Linha 2 -->

          <div class="row pt-3">

            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Lote Rw - Exemplo: AB1234567 </mat-label>
                <input matInput id="txtLoteRw" #txtLoteRw maxlength="9" formControlName="Lote_rw">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintLoteRw}}</mat-hint>
                <mat-hint align="end">{{txtLoteRw.value.length}} / 9</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Lote_rw)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Umidade (%)</mat-label>
                <input matInput id="txtUmid" #txtUmid maxlength="5" formControlName="Umidade"
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" currencyMask (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtUmid.value.length}} / 5</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Umidade)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Gleba
                </mat-label>
                <input matInput id="txtGleba" #txtGleba maxlength="80" readonly formControlName="Gleba"
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtGleba.value.length}} / 80</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Gleba)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Contrato Jurídico</mat-label>
                <input matInput id="txtContrato" #txtContrato maxlength="20" formControlName="Contrato_Juridico"
                  readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtContrato.value.length}} / 20</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Contrato_Juridico)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 2 -->

          <!-- Linha 3 -->

          <div class="row pt-3">
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Site Recebimento</mat-label>
                <input matInput id="txtSiteRecebimento" #txtSiteRecebimento maxlength="10" readonly
                  formControlName="Site_Recebimento" class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtSiteRecebimento.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Site_Recebimento)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Site Origem</mat-label>
                <input matInput id="txtSiteOrigem" #txtSiteOrigem maxlength="20" readonly formControlName="Site_Origem"
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtSiteOrigem.value.length}} / 20</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Site_Origem)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Cooperante</mat-label>
                <input matInput id="txtCooperante" #txtCooperante maxlength="80" readonly formControlName="Cooperante"
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtCooperante.value.length}} / 80</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Cooperante)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Número do Campo (Básica)</mat-label>
                <input matInput id="txtNumCampo" #txtNumCampo maxlength="20" [readonly]="true"
                  formControlName="Nr_campo" class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtNumCampo.value.length}} / 20</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Nr_campo)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Produto
                </mat-label>
                <input matInput id="txtProduto" #txtProduto maxlength="80" formControlName="Produto"
                  class="InputBlockColor" readonly>
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtGleba.value.length}} / 80</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Gleba)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 3 -->

          <!-- Inicio Linha 4 -->

          <div class="row pt-3">
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso Líquido (kg)</mat-label>
                <input matInput id="txtPesoLiquido" #txtPesoLiquido maxlength="10" formControlName="Peso_Liquido"
                  currencyMask class="InputBlockColor" readonly>
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtPesoLiquido.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_Liquido)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso da Amostra MILHO (g)</mat-label>
                <input matInput id="txtPesoAmostraMilho" #txtPesoAmostraMilho maxlength="9"
                  formControlName="Peso_Amostra" currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                  (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPesoAmostraMilho.value.length}} / 9</mat-hint>
                <mat-error *ngIf="formulario.get('Palha').hasError('max')">O valor máximo é 20.000.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Palha (g)</mat-label>
                <input matInput id="txtPalha" #txtPalha maxlength="9" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" (blur)="makeCalculations()"
                  formControlName="Palha">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPalha.value.length}} / 9</mat-hint>
                <mat-error *ngIf="formulario.get('Palha').hasError('max')">O valor máximo é 20.000.</mat-error>
                <mat-error>{{ hasErrorFormControl(formulario.controls.Palha) }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Impurezas (g)</mat-label>
                <input matInput id="txtOutrasSementes" #txtImpurezas maxlength="9" formControlName="Impurezas"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }" (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtImpurezas.value.length}} / 9</mat-hint>
                <mat-error *ngIf="formulario.get('Impurezas').hasError('max')">O valor máximo é 20.000.</mat-error>
                <mat-error>{{ hasErrorFormControl(formulario.controls.Impurezas) }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Outras Sementes (espécies) (g)</mat-label>
                <input matInput id="txtOutrasSementes" #txtOutrasSementes maxlength="9"
                  formControlName="Outras_Sementes" currencyMask (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtOutrasSementes.value.length}} / 9</mat-hint>
                <mat-error *ngIf="formulario.get('Palha').hasError('max')">O valor máximo é 20.000.</mat-error>
                <mat-error>{{ hasErrorFormControl(formulario.controls.Outras_Sementes) }}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 4 -->
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>
<div class="row" *ngIf="isPreBasica">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <!-- Inicio Linha 1 -->

          <div class="row pt-3">
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Site Recebimento
                  <span class="InputRequired">{{required}}</span>
                </mat-label>
                <input matInput id="txtSiteRecebimento" #txtSiteRecebimento maxlength="10" readonly
                  formControlName="site_recebimento" class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtSiteRecebimento.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.site_recebimento)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">{{hintSafraPreBasicaLabel}}
                  <span class="InputRequired">{{required}}</span>
                </mat-label>
                <input matInput id="txtSafraBasica" class="text-uppercase" txtSafraBasica maxlength="5"
                  (blur)="makeCalc($event)" formControlName="safra_basica">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.safra_basica)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Cerar (Básica)<span class="InputRequired">{{required}}</span>
                </mat-label>

                <input matInput id="txtCerarBasica" #txtCerarBasica maxlength="10" formControlName="cerar_basica"
                  appOnlyNumberVirgula (blur)="getPesoRWFromQua007($event)">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-hint align="end">{{txtCerarBasica.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.cerar_basica)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-1 col-md-3 col-xs-6 col-sm-6 btnAlignSelf">
              <button mat-flat-button color="primary" matTooltip="Leitor Cerar" (click)="openDialog()"
                class="btnSize align-self-end" [disabled]="disableBtnCerar">
                <i class="{{iconBarCodeField}}"></i> Leitor Cerar
              </button>
            </div>
          </div>

          <!-- Fim Linha 1 -->

          <!-- Linha 2 -->

          <div class="row pt-3">

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Lote Rw - Exemplo: E1DGRAO001 </mat-label>
                <input matInput id="txtLoteRw" #txtLoteRw maxlength="10" formControlName="lote_rw">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">Padrão: E+número+letra+GRAO+numero </mat-hint>
                <mat-hint align="end">{{txtLoteRw.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.lote_rw)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Número do Campo (Básica)</mat-label>
                <input matInput id="txtNumCampo" #txtNumCampo maxlength="20" appOnlyNumberVirgula
                  formControlName="numero_campo" (blur)="makeCalc()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtNumCampo.value.length}} / 20</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.numero_campo)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Geração</mat-label>
                <input matInput id="txtGeracao" #txtGeracao maxlength="20" readonly formControlName="geracao"
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtGeracao.value.length}} / 20</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.geracao)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Contrato Jurídico</mat-label>
                <input matInput id="txtContrato" #txtContrato maxlength="20" formControlName="contrato_juridico"
                  readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtContrato.value.length}} / 20</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.contrato_juridico)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Gleba
                </mat-label>
                <input matInput id="txtGleba" #txtGleba maxlength="1" formControlName="gleba">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-hint align="end">{{txtGleba.value.length}} / 1</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.gleba)}}</mat-error>
              </mat-form-field>
            </div>



          </div>

          <!-- Fim Linha 2 -->

          <!-- Linha 3 -->

          <div class="row pt-3">

            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Site Origem</mat-label>
                <input matInput id="txtSiteOrigem" #txtSiteOrigem maxlength="20" readonly formControlName="site_origem"
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtSiteOrigem.value.length}} / 20</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.site_origem)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Cooperante</mat-label>
                <input matInput id="txtCooperante" #txtCooperante maxlength="80" readonly formControlName="cooperante"
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtCooperante.value.length}} / 80</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.cooperante)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <!--  novo campo Manufatura/linhagem -->
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Manufatura/linhagem</mat-label>
                <input matInput id="txtManufatura" #txtManufatura maxlength="80" [readonly]="true"
                  formControlName="hibrido_rnc" class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtManufatura.value.length}} / 80</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.hibrido_rnc)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Espécie</mat-label>
                <input matInput id="txtEspecie" #txtEspecie maxlength="10" readonly formControlName="especie"
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtEspecie.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.especie)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Tipo Colheita</mat-label>
                <input matInput id="txtTpColheita" #txtEspecie maxlength="10" readonly formControlName="tipo_colheita"
                  class="InputBlockColor">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtEspecie.value.length}} / 10</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 3 -->

          <!-- Inicio Linha 4 -->

          <div class="row pt-3">
            <div class="col-sm">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Umidade Cerar (%)</mat-label>
                <input matInput id="txtUmid" #txtUmid maxlength="6" formControlName="umidade"
                  [options]="{ thousands: '.', decimal: ',', precision: 2, suffix: '%' }" currencyMask>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.umidade)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Amostra seca ou molhada</mat-label>
                <mat-select formControlName="amostra_seca_molhada"
                  (selectionChange)="makeCalculationsPreBasica($event)">
                  <mat-option *ngFor="let item of listAmostra" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-error>{{hasErrorFormControl(formulario.controls.amostra_seca_molhada)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso total RW</mat-label>
                <input matInput id="txtPesoTotalRW" #txtPesoTotalRW maxlength="5" formControlName="peso_total_rw"
                  currencyMask readonly [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                </mat-hint>
                <mat-hint align="end">{{txtPesoTotalRW.value.length}} / 5</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.peso_total_rw )}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 4 -->
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>